import { render, staticRenderFns } from "./DraftPageIcon.vue?vue&type=template&id=adcfbbd0"
import script from "./DraftPageIcon.vue?vue&type=script&lang=ts"
export * from "./DraftPageIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports